import { router } from "@/app/router/router";
import RouteNames from "@/app/router/routes";
import { ProblemDetails, SwaggerException } from "@/app/api/battery-portal-api";
import { notify } from "@kyvg/vue3-notification";
export class Notifier {
    static onOk(message) {
        if (!message)
            message = "Your changes have been successfully saved.";
        notify({
            group: "global",
            type: "success",
            title: "Success",
            text: message,
            duration: 2000
        });
    }
    ;
    static onWarning(message) {
        notify({
            group: "global",
            type: "warn",
            title: "Attention",
            text: message,
            duration: 5000
        });
    }
    ;
    static onError(message) {
        notify({
            group: "global",
            type: "error",
            title: "Something went wrong...",
            text: message,
            duration: 5000
        });
    }
    ;
    static onServerError(ex) {
        let message = this.getErrorMessage(ex);
        if (this.errorIsHtmlPage(message)) {
            router.push(RouteNames.Errors);
            return;
        }
        notify({
            group: "global",
            type: "error",
            title: "Something went wrong...",
            text: message,
            duration: 5000
        });
    }
    ;
    static getErrorMessage(ex) {
        try {
            if (!ex.isSwaggerException)
                return Notifier.describeError(ex);
            if (ex instanceof SwaggerException && ex.result instanceof ProblemDetails)
                return Notifier.describeProblem(ex.result);
            let swaggerEx = ex;
            let problem = ProblemDetails.fromJS(JSON.parse(swaggerEx.response));
            if (problem.title)
                return Notifier.describeProblem(problem);
            return ex.response.replace(/"/g, "");
        }
        catch (e) {
            return Notifier.DefaultErrorMessage;
        }
    }
    ;
    static describeProblem(problem) {
        if (!problem)
            return Notifier.DefaultErrorMessage;
        let title = problem.title || `Unexpected error`;
        if (!problem.detail)
            return `${title}`;
        return `${title} \n ${problem.detail}`;
    }
    ;
    static describeError(error) {
        try {
            if (!error)
                return Notifier.DefaultErrorMessage;
            // error has a response object. attempt to parse it.
            if (error.response) {
                let obj = JSON.parse(error.response);
                if (!obj)
                    return Notifier.DefaultErrorMessage;
                if (obj.error)
                    return `${obj.error}`;
                if (obj.message)
                    return `${obj.message}`;
            }
            // error has a message property.
            if (error.message)
                return `${error.message}`;
            // error is a string
            if (error instanceof String)
                return `${error}`;
            return Notifier.DefaultErrorMessage;
        }
        catch (e) {
            return Notifier.DefaultErrorMessage;
        }
    }
    static errorIsHtmlPage(msg) {
        return msg.indexOf("<html") >= 0;
    }
    ;
}
Notifier.DefaultErrorMessage = "Unknown error has occurred.";
